import { render, staticRenderFns } from "./Justificativa.vue?vue&type=template&id=2b11b950"
import script from "./Justificativa.vue?vue&type=script&lang=js"
export * from "./Justificativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports